import * as Dialog from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';

/**
 * A centred confirmation or short form (board #667): a title, one line, the body, and the buttons
 * the caller passes. Side sheets stay for pickers; yes/no questions and short forms are centred.
 */
export function ClosingDialog({
  title,
  description,
  children,
  actions,
  onClose,
}: {
  readonly title: string;
  readonly description?: string | undefined;
  readonly children?: ReactNode;
  readonly actions: ReactNode;
  readonly onClose: () => void;
}) {
  return (
    <Dialog.Root open onOpenChange={(next) => (next ? undefined : onClose())}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-[var(--scrim)]" />
        <Dialog.Content className="border-border bg-card fixed top-1/2 left-1/2 z-50 grid max-h-[90vh] w-[min(28rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 gap-4 overflow-y-auto rounded-xl border p-6 shadow-lg">
          <Dialog.Title className="text-foreground text-lg font-semibold">{title}</Dialog.Title>
          <Dialog.Description className="text-muted-foreground text-sm">
            {description ?? ''}
          </Dialog.Description>
          {children}
          <div className="flex flex-wrap justify-end gap-2">{actions}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
